import { inject, Injectable, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ENVIRONMENT, Environment } from '@shared/environment';
import { MessageContentType, ONLINESTATUS } from '@shared/common';
import { StorageHelperService } from '@shared/services';

export enum ConnectionState {
	disconnected,
	connected,
	connecting,
}

declare var $: any;

@Injectable({
	providedIn: 'root',
})
export class ChatService implements OnInit {
	private connection: any;
	private connectionChat: any;
	private proxy: any;
	connected: boolean = false;
	public connectionState = ConnectionState.disconnected;

	missionAnnouncedSource = new Subject<string>();
	// Observable string streams
	missionAnnounced$ = this.missionAnnouncedSource.asObservable();
	// Service message commands

	// closeConversationAnnounce
	private closeConversationAnnounce = new Subject<void>();
	closeConversationAnnounce$ = this.closeConversationAnnounce.asObservable();

	// announce new message
	private messageAnnounceSource = new Subject<any>();
	messageAnnounce$ = this.messageAnnounceSource.asObservable();

	// announce client on/off
	private clientAnnounceSource = new Subject<any>();
	clientAnnounce$ = this.clientAnnounceSource.asObservable();

	// announce get list user
	private listUserAnnounceSource = new Subject<any>();
	listUserAnnounce$ = this.listUserAnnounceSource.asObservable();

	// announce get group
	private groupAnnounceSource = new Subject<any>();
	groupAnnounce$ = this.groupAnnounceSource.asObservable();

	// announce get history
	private historyAnnounceSource = new Subject<any>();
	historyChatAnnounce$ = this.historyAnnounceSource.asObservable();

	// announce get recent
	private recentAnnounceSource = new Subject<any>();
	recentChatAnnounce$ = this.recentAnnounceSource.asObservable();

	// success connect
	private successConnectAnnounceSource = new Subject<any>();
	connectSuccessAnnounce$ = this.successConnectAnnounceSource.asObservable();

	// connection failure
	private connectFailureAnnounceSource = new Subject<string>();
	connectFailureAnnounce$ = this.connectFailureAnnounceSource.asObservable();

	// announce unread message count
	private unreadCountAnnounceSource = new Subject<any>();
	unreadSuccessAnnounce$ = this.unreadCountAnnounceSource.asObservable();

	// announce group name change
	private setGroupNameAnnounceSource = new Subject<any>();
	setGroupNameAnnounce$ = this.setGroupNameAnnounceSource.asObservable();

	// annoucse recent chat no favourite
	private getRecentChatNoFavouriteSource = new Subject<any>();
	getRecentChatNoFavourtiteAnnounce$ =
		this.getRecentChatNoFavouriteSource.asObservable();

	// get job chat
	private getJobChatAnnounce = new Subject<any>();
	getJobChatAnnounce$ = this.getJobChatAnnounce.asObservable();

	// annouce user change info
	private userChangeInfoAnnounceSource = new Subject<any>();
	userChangeInfoAnnounce$ = this.userChangeInfoAnnounceSource.asObservable();

	// annouce user change info
	private deleteGroupEvent = new Subject<any>();
	deleteGroup$ = this.deleteGroupEvent.asObservable();

	openMessageAnnounced = new Subject<any>();
	// Observable string streams
	openMessageAnnounced$ = this.openMessageAnnounced.asObservable();

	closeMessageAnnounced = new Subject<any>();
	// Observable string streams
	closeMessageAnnounced$ = this.closeMessageAnnounced.asObservable();

	// annouce user change info
	public addGroupEvent = new Subject<void>();
	addGroup$ = this.addGroupEvent.asObservable();

	private chatSignalr: string;
	private timeReconnect = 1;
	private isReady = false;
	private readonly environment = inject<Environment>(ENVIRONMENT);
	constructor(
		private http: HttpClient,
		private toastrService: ToastrService,
		private storageHelper: StorageHelperService
	) {}

	ngOnInit() {
		// if (environment.platform === 'web') {
		// 	this.initConnection().then((connection) => {
		// 		this.connection = connection;
		// 	});
		// } else {
		// 	document.addEventListener('deviceready', () => {
		// 		this.initConnection().then((connection) => {
		// 			this.connection = connection;
		// 		});
		// 	});
		// }
	}

	async initConnection() {
		this.chatSignalr = this.environment.env.chatSignalr;
		const hubUrl = this.chatSignalr + '/chathub';
		const connectionL = $.hubConnection(hubUrl);
		const token = await this.storageHelper.getItem('token');
		const companyCode = await this.storageHelper.getItem('companyCode');
		connectionL.qs = {
			tokenCC: () => {
				return typeof companyCode === 'undefined' ||
					companyCode === null
					? ''
					: companyCode;
			},
			access_token: () => {
				// Obtain token from ADAL JS cache.
				let jwtToken = '';
				if (token) {
					jwtToken = token.substring(7);
				}
				return typeof jwtToken === 'undefined' || jwtToken === null
					? ''
					: jwtToken;
			},
		};
		const proxyL = connectionL.createHubProxy('chatHub');
		// listen
		proxyL.on('onMessageReceived', latestMsg => {
			this.onMessageReceived(latestMsg);
		});
		proxyL.on('onGetGroup', group => this.onGetGroup(group));
		proxyL.on('onClientChangeStatus', client =>
			this.onClientChangeStatus(client)
		);
		proxyL.on('onGetListUser', list => this.onGetListUser(list));
		proxyL.on('onGetRecentChat', list => this.onGetRecentChat(list));
		proxyL.on('onGetHistoryChat', list => this.onGetHistoryChat(list));
		proxyL.on('onGetRecentChatNoFavourite', list =>
			this.onGetRecentChatNoFavourite(list)
		);

		proxyL.on('onGetJobChat', list => this.getJobChatAnnounce.next(list));
		proxyL.on('onGetUnreadMessageCount', list =>
			this.onGetUnreadMessageCount(list)
		);
		proxyL.on('onSetGroupName', group => this.onSetGroupName(group));
		proxyL.on('onSetUserGroupName', userGroup =>
			this.onSetUserGroupName(userGroup)
		);
		proxyL.on('onUpdateUserInfo', user => {
			this.onUpdateUserInfo(user);
		});
		return {
			proxyL,
			connectionL,
		};
	}
	announceMission(mission: string) {
		this.missionAnnouncedSource.next(mission);
	}

	startConnection(): void {
		if (this.connectionState === ConnectionState.disconnected) {
			this.connectionState = ConnectionState.connecting;
			if (!this.connection && !this.proxy) {
				this.initConnection()
					.then(connection => {
						this.connection = connection.connectionL;
						this.proxy = connection.proxyL;
						this.start();
					})
					.catch(err => {
						console.error('[ChatHub] initConnection failed:', err);
						this.connectionState = ConnectionState.disconnected;
						this.connectFailureAnnounceSource.next(
							err?.message ?? 'Init failed'
						);
					});
			} else {
				this.start();
			}
		}

		if (this.connectionState === ConnectionState.connected) {
			this.successConnectAnnounceSource.next('success');
			this.getUnreadMessageCount();
			this.connected = true;
		}
	}

	async reconnect() {
		try {
			this.start();
		} catch (err) {
			this.timeReconnect++;
			this.timeReconnect =
				this.timeReconnect > 1800 ? 0 : this.timeReconnect;
			setTimeout(() => this.reconnect(), this.timeReconnect * 2000);
		}
	}

	start() {
		this.connection
			.start()
			.done((data: any) => {
				if (data) {
					this.successConnectAnnounceSource.next('success');
					this.getUserList();
					this.getUnreadMessageCount();
					this.connected = true;
					this.connectionState = ConnectionState.connected;
				}
			})
			.fail((error: any) => {
				console.error('[ChatHub] Connection failed:', error);
				this.connectionState = ConnectionState.disconnected;
				this.connectFailureAnnounceSource.next(
					error?.message ?? 'Connection failed'
				);
			});
	}
	getUserList() {
		this.getListUserIDS().subscribe((data: any) => {
			if (data) {
				data = data.$values;
				sessionStorage.removeItem('listuser');
				sessionStorage.setItem('listuser', JSON.stringify(data));
			}
		});
	}

	// listen create chat group result
	private onGetGroup(group: any) {
		this.groupAnnounceSource.next(group);
	}

	// request favourite chat group
	// callback response
	getFavouriteChatGroups(completionHandler: (result: any) => void): void {
		this.proxy.invoke('getFavouriteChatGroups');
		this.proxy.on('onGetFavouriteChatGroups', resp =>
			completionHandler(resp)
		);
	}

	// handle listening function
	// listen receive message from server
	private onMessageReceived(message) {
		this.messageAnnounceSource.next(message);
	}

	onCloseConversationAnnounce() {
		this.closeConversationAnnounce.next();
	}

	// listen get list user
	private onGetListUser(list: any) {
		this.listUserAnnounceSource.next(list);
	}

	// listen client change status on/off
	private onClientChangeStatus(client) {
		this.setConnections(client);
		this.clientAnnounceSource.next(client);
	}

	// get list history chat
	private onGetHistoryChat(list) {
		this.historyAnnounceSource.next(list);
	}

	// listen send message result
	private onSendMessage(message) {}

	// listen get recent chat
	private onGetRecentChat(list) {
		this.recentAnnounceSource.next(list);
	}

	private onGetRecentChatNoFavourite(list) {
		this.getRecentChatNoFavouriteSource.next(list);
	}

	// listen set group name
	private onSetGroupName(group) {
		this.setGroupNameAnnounceSource.next(group);
	}

	private onSetUserGroupName(resp) {}

	// send message to server
	sendMessage(groupID: number, message: string) {
		this.proxy.invoke('sendMessage', groupID, message);
	}

	sendMessageWithType(
		groupID: number,
		message: string,
		type: number,
		woid: number = 0
	) {
		this.proxy.invoke('sendMessageWithType', groupID, message, type, woid);
	}

	// REST API
	setFavouriteGroup(userGroupID) {
		return this.http.get(
			this.chatSignalr + '/api/Messenger/setFavouriteGroup',
			{
				params: new HttpParams().set('userGroupID', userGroupID),
			}
		);
	}

	// REST API
	searchMessage(userId, groupID, keyword) {
		return this.http.get(this.chatSignalr + '/api/Messenger/search', {
			params: new HttpParams()
				.set('userId', userId)
				.set('groupID', groupID)
				.set('keyword', keyword),
		});
	}

	// REST API Messenger/changeStatus
	changeStatus(status) {
		this.proxy.invoke('changeOnlineStatus', status);
	}

	// REST API Messenger/getMessengerStatus
	getMyStatus() {
		return this.http.get(
			this.chatSignalr + '/api/Messenger/getMessengerStatus',
			{}
		);
	}

	// REST API
	setBlockNotification(userChatgroup) {
		return this.http.post(
			this.chatSignalr + '/api/UserChatGroup/setBlockNotification',
			userChatgroup
		);
	}
	getGroupChatApi(data: any) {
		return this.http.post(
			this.chatSignalr + '/api/ChatGroup/getGroup',
			data
		);
	}

	// get list user
	getAllUser() {
		this.proxy.invoke('getListUser');
	}

	// get unread message count
	getUnreadMessageCount() {
		this.proxy.invoke('getUnreadMessageCount');
	}

	// get group chat
	// param: array of user in group, include user make request
	getGroupChat(data: any) {
		this.proxy.invoke('getGroup', data);
	}

	setGroupName(groupID: number, name: string) {
		this.proxy.invoke('setGroupName', groupID, name);
	}

	setUserGroupName(groupID: number, userGroupID, name: string) {
		this.proxy.invoke('setUserGroupName', groupID, userGroupID, name);
	}

	// delete message
	// callback response
	deleteMessage(
		messageID: number,
		completionHandler: (result: any) => void
	): void {
		this.proxy.invoke('deleteMessage', messageID);
		this.proxy.on('onDeleteMessage', resp => completionHandler(resp));
	}

	// delete group
	deleteGroup(
		messageID: number,
		woid = 0,
		completionHandler: (result: any) => void
	): void {
		this.proxy.invoke('deleteGroup', messageID, woid);
		this.proxy.on('onDeleteGroup', resp => {
			this.deleteGroupEvent.next(resp);
			completionHandler(resp);
		});
	}

	// get recent chat
	// params:  - first argument: page size
	//          - second argument: page index
	getRecentChat(pageSize: number, pageIndex: number) {
		this.proxy.invoke('getRecentChat', pageSize, pageIndex);
	}

	getRecentChatNoFavourite(pageSize: number, pageIndex: number) {
		this.proxy.invoke('getRecentChatNoFavourite', pageSize, pageIndex);
	}

	getJobChat(pageSize: number, pageIndex: number, jobid: number) {
		this.proxy.invoke('getJobChat', pageSize, pageIndex, jobid);
	}
	// get history chat
	// params:  - first argument: group chat id
	//          - second argument: page size
	//          - third argument: page index
	getHistoryChat(groupID: number, pageSize: number, pageIndex: number) {
		this.proxy.invoke('getHistoryChat', groupID, pageSize, pageIndex);
	}

	getHistoryChatApi(groupID: number, pageSize: number, pageIndex: number) {
		return this.http.get(
			this.chatSignalr + '/api/Messenger/getHistoryChat',
			{
				params: {
					groupID: groupID.toString(),
					pageSize: pageSize.toString(),
					pageIndex: pageIndex.toString(),
				},
			}
		);
	}

	// REST API
	uploadImage(groupID: number, file: File) {
		const formData: FormData = new FormData();
		formData.append('files', file, file.name);
		return this.http.post(
			this.chatSignalr + '/api/Messenger/SendImage/' + groupID,
			formData
		);
	}

	// REST API
	uploadFile(groupID: number, file: File) {
		const formData: FormData = new FormData();
		formData.append('files', file, file.name);
		return this.http.post(
			this.chatSignalr + '/api/Messenger/SendFile/' + groupID,
			formData
		);
	}

	// Copy Image S3
	copyImage(groupID: number, photo) {
		return this.http.post(
			this.chatSignalr + '/api/Messenger/CopyImage/' + groupID,
			photo
		);
	}

	// Copy File S3
	copyFile(groupID: number, document) {
		return this.http.post(
			this.chatSignalr + '/api/Messenger/CopyFile/' + groupID,
			document
		);
	}

	// REST API
	downloadFile(messageID: number) {
		return this.http.get(
			this.chatSignalr + '/api/Messenger/downloadFile/' + messageID
		);
	}

	markAllAsRead() {
		this.proxy.invoke('markAllAsRead');
	}

	updateUsersInfo() {
		this.proxy.invoke('updateUserInfo');
	}

	pushNotification(notification) {
		let audio = new Audio('../../assets/unconvinced.mp3');
		if (notification.checkAudio) {
			audio.play();
		}
		this.toastrService.show(
			notification.notiMessage.Notification_Content,
			notification.notiMessage.Notification_Title,
			{
				timeOut: 10000,
				enableHtml: true,
				toastClass: 'toast',
			},
			'home'
		);
	}

	private onGetUnreadMessageCount(count) {
		this.unreadCountAnnounceSource.next(count);
	}

	getConnectStatus() {
		return this.connected;
	}

	disconnect() {
		this.connected = false;
		this.connectionState = ConnectionState.disconnected;
		if (this.connection) {
			this.connection.stop();
		}
	}

	getListUserIDS() {
		return this.http.get('/api/users/company/1');
	}

	getListUserDetailByList(data: any) {
		return this.http.post('/api/users/detailbylist', data);
	}

	getConnections() {
		const result = sessionStorage.getItem('connections');
		return result && result.length > 0 ? JSON.parse(result) : [];
	}

	setConnections(connect) {
		const connections = this.getConnections();
		const result = connections
			.map(x => x)
			.filter(x => x.UserId !== connect.UserId);
		result.push(connect);
		sessionStorage.setItem('connections', JSON.stringify(result));
		return result;
	}
	isStatus(userId) {
		const connections = this.getConnections();
		const result = connections.map(x => x).filter(x => x.UserId === userId);
		return userId && result[0] ? ONLINESTATUS[result[0].Status] : 'Offline';
	}

	/**
	 * isStatusOnline - get status of group chat or chat 1-1
	 *
	 * @param  {any} val array of ChatGroups or strign of userid
	 * @return {string}     Online, Offline
	 */
	isStatusOnline(val) {
		if (Array.isArray(val)) {
			const chatGroups = val;
			const status = ['Online', 'Away'];
			const userId = sessionStorage.getItem('userID');
			if (chatGroups.length <= 2) {
				// chat 1-1
				const arrayStatus = chatGroups
					.map(x => x.User_Id)
					.filter(x => x != userId) // except current user
					.map(x => this.isStatus(x))
					.filter(x => status.indexOf(x) > -1);
				return arrayStatus[0] || 'Offline';
			} else {
				const arrayStatus = chatGroups
					.map(x => x.User_Id)
					.map(x => this.isStatus(x))
					.filter(x => status.indexOf(x) > -1);
				return arrayStatus[0] ? 'Online' : 'Offline';
			}
		} else {
			return this.isStatus(val) || 'Offline';
		}
	}

	private onUpdateUserInfo(user) {
		let list = JSON.parse(sessionStorage.getItem('listuser'));
		list = list.map(x => {
			if (x.ID === user.ID) {
				Object.assign(user, {
					Employee: x.Employee,
				});
				return user;
			}
			return x;
		});
		sessionStorage.setItem('listuser', JSON.stringify(list));
		this.userChangeInfoAnnounceSource.next(user);
	}

	getContentPreview(message: any): string {
		const split = message.Message_Content.split('/');
		const fullname = split.pop();
		// remove datetime
		const name = this.getFileRealName(fullname);
		switch (message.Type) {
			case MessageContentType.image:
				return name;
			case MessageContentType.file:
				return name;
			default:
				return message.Message_Content;
		}
	}

	// remove datetime string in file name
	getFileRealName(fullFileName: string): string {
		let output = '';
		if (fullFileName.split('.').length > 0) {
			const name = fullFileName.split('.')[0];
			const ext =
				fullFileName.split('.')[fullFileName.split('.').length - 1];
			const arrName = name.split('_');
			if (arrName.length > 1) {
				arrName.pop();
				const realName = arrName.join('_');
				output = realName + '.' + ext;
			} else {
				output = name + '.' + ext;
			}
		} else {
			output = fullFileName;
		}
		return output;
	}
}
